//import Cep from "cep-promise";
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import business from '../../services/business';
import Loading from '../Loading';
import Modal from '../Modal';
import config from '../../config/config';
import tools from '../../lib/tools';
import { toast as alert } from "react-toastify";

export default function ModalConvidados({ hideModal, show, processo = {} }) {

    const [convidados, setConvidados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [change, setChange] = useState(false);

    useEffect(() => {
        (async (loading = true) => {
            setLoading(loading);
            let response = await business.getConvidados(processo?.id, {});
            setConvidados(response)
            setLoading(false);
        })();
    }, [processo?.id, change]);

    const aceiteManual = async (id, nome) => {
        if (!window.confirm(`Você deseja aceitar o convite de ${nome}?`)) {
            return false;
        }
        await business.aceitaConviteManual(id);
        setChange(!change);
    }

    const recusaManual = async (id, nome) => {
        if (!window.confirm(`Você deseja recusar o convite de ${nome}?`)) {
            return false;
        }
        await business.recusaConviteManual(id);
        setChange(!change);
    }

    const copiarLink = (link) => {
        tools.copyToClipboard(link);
        alert.success('Link copiado para a área de transferência!');
    }

    return (
        <Modal show={show} handleClose={hideModal} style={{ maxWidth: '1200px', maxHeight: '600px' }} modalClass="modal-cad-usuario">
            <div className="flex">
                <div className="form w-100">
                    <h1 className="title mb-25">Desempatadores convidados</h1>
                    {loading ? (<Loading />) : (<div>
                        {!convidados ? ('Não há desempatadores convidados à participar deste processo.') : (
                            <div className="grid col-12 fb-16 p-10">
                                <div className="span-4">Nome completo</div>
                                <div className="span-2">Canal</div>
                                <div className="span-4">Contato</div>
                                <div className="span-1">Status</div>
                                {(config.isSaastoOperationalUser()) && (<div className="span-1 text-right">Ações</div>)}
                            </div>
                        )}

                        {/* 🎯 IDENTIFICA OS 4 ACEITOS MAIS ANTIGOS PELA DATA DE ALTERAÇÃO */}
                        {(() => {
                            // 1. Limpa marcações anteriores para evitar duplicidade em re-renders
                            (convidados || []).forEach(c => delete c.escolhido);

                            // 2. Filtra aceitos (status 4)
                            const aceitos = (convidados || []).filter(
                                c => parseInt(c.id_notificacao_envio_status) === 4 && c.data_atualizacao
                            );

                            // 3. Ordena ASC (Mais antigo primeiro)
                            aceitos.sort((a, b) => {
                                const dataA = new Date(a.data_atualizacao);
                                const dataB = new Date(b.data_atualizacao);
                                return dataA - dataB; // Ordem decrescente
                            });

                            // 4. Marca os 4 primeiros da lista resultante
                            aceitos.slice(0, 4).forEach((item, index) => {
                                item.escolhido = index + 1;
                            });

                            return null;
                        })()}

                        {/* LISTA */}
                        {(convidados || []).map((item, i) => (
                            <div key={i}>
                                {item.id_notificacao_canal >= 1 && (
                                    <div className={`grid col-12 convidados hover-highlight fn-14 ${parseInt(item.id_notificacao_envio_status) === 4 ? 'aceito' : parseInt(item.id_notificacao_envio_status) === 5 ? 'recusado' : ''}`} style={{ borderBottom: '1px solid gray' }} >
                                        <div className="span-4">{item.escolhido && (
                                            <span style={{ marginRight: 5 }}>[{item.escolhido}]</span>
                                        )}{item.nome_desempatador}</div>
                                        <div className="span-2">{item.desc_notificacao_canal}</div>
                                        <div className="span-4">{parseInt(item.id_notificacao_canal) === 2 && item.email_desempatador}{parseInt(item.id_notificacao_canal) === 3 && item.telefone_desempatador.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3")}</div>
                                        <div className="span-1">{item.desc_notificacao_envio_status}</div>
                                        {(config.isSaastoOperationalUser()) && (
                                            <div className="span-1 text-center" style={{ display: 'flex', textAlign: 'center', justifyContent: 'flex-end' }}>
                                                {(config.isAdmin() || config.isEnfermeira()) && (
                                                    <i className="icon icon-check i-15 pointer ml-10"
                                                        title="Aceitar manualmente"
                                                        onClick={() => aceiteManual(item.notificacao_envio_id, item.nome_desempatador)}
                                                    ></i>)}
                                                {(config.isAdmin() || config.isEnfermeira()) && (
                                                    <i className="icon icon-cross-small i-20 pointer ml-10"
                                                        title="Recusar manualmente"
                                                        onClick={() => recusaManual(item.notificacao_envio_id, item.nome_desempatador)}
                                                    ></i>)}
                                                {(config.isSaastoOperationalUser()) && item.link && (
                                                    <i className="icon icon-duplicate i-15 pointer ml-10"
                                                        title="Copiar link"
                                                        onClick={() => copiarLink(item.link)}
                                                    ></i>)}
                                            </div>)}
                                    </div>)}
                            </div>))}
                    </div>)}
                </div>
            </div>
        </Modal>
    );
}
